import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { MiniFooter } from '@app/src/common/MiniFooter';
import { ButtonsAction } from '@app/src/common/ButtonsAction';
import {
  ButtonPrevWrapper,
  ButtonNextWrapper,
  ButtonActionsWrapper,
  Wrapper
} from './styled';
import { isClientEnv } from '@app/src/utils/validations';
import { useHistory, useParams } from 'react-router-dom';

const isClient = isClientEnv();
const BREAKPOINT = 768;

interface Props {
  categoryConfig?: any;
  priceTotal?: string;
  handleClickSubmit?: Function;
  disabledButtonNext?: boolean;
  textButtonNext?: string;
}

export const FormActions: React.FC<Props> = ({
  categoryConfig,
  handleClickSubmit,
  disabledButtonNext,
  textButtonNext
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [isFixedActionsButtons, setIsFixedActionsButtons] = useState(false);
  let active = false;
  const [isDisabledScroll, setIsDisabledScroll] = useState(false);
  const refWrapper = useRef(null);
  const refFooter = useRef(null);

  useEffect(() => {
    if (isClient) {
      if (window.innerWidth < BREAKPOINT) {
        window.addEventListener('scroll', handleScroll);
      }
      window.addEventListener('resize', handleResizeWindow);
      return () => {
        window.removeEventListener('resize', handleResizeWindow);
        if (window.innerWidth < BREAKPOINT) {
          window.removeEventListener('scroll', handleScroll);
        }
      }
    }
  }, []);

  const handleResizeWindow = useCallback(() => {
    if (window.innerWidth >= BREAKPOINT) {
      setIsFixedActionsButtons(false);
      window.removeEventListener('scroll', handleScroll)
    } else {
      window.addEventListener('scroll', handleScroll)
      if (active) {
        active = false;
      }
    }
  }, [dispatch]);

  const disabledScroll = () => {
    setIsDisabledScroll(false)
    setTimeout(() => {
      setIsDisabledScroll(true)
    }, 500)
  }

  const handleScroll = useCallback(() => {
    const bodyHeight = document.body.offsetHeight;
    const fixedElementHeight = refWrapper.current.offsetHeight;
    const footerHeight = refFooter.current.offsetHeight;

    if (!isDisabledScroll) {
      if ( bodyHeight - (window.pageYOffset + window.innerHeight) > fixedElementHeight && active === false) {
        active = true;
        setIsFixedActionsButtons(true);
        disabledScroll();
      }
      if ( bodyHeight - (window.pageYOffset + window.innerHeight) <= footerHeight && active === true) {
        active = false;
        setIsFixedActionsButtons(false)
        disabledScroll()
      }
    }
  }, [dispatch])

  const handleClickGoBack = (e) => {
    e.preventDefault();
    history.push(`${categoryConfig.link}-3/${id}`);
  }

  return (
    <Wrapper  ref={refWrapper}>
      <ButtonActionsWrapper fixed={isFixedActionsButtons} >
        <ButtonsAction
          ButtonPrev={
            <ButtonPrevWrapper
              handleClick={handleClickGoBack}
              background='#fff'
              color={categoryConfig.color}
              width={140}
              text="Confirmar publicación"
              icon={{name:'icon-back', color: categoryConfig.color, width:'16'}}
              left
            />
          }
          ButtonNext={
            <ButtonNextWrapper
              id="paymentAction"
              handleClick={handleClickSubmit}
              background={categoryConfig.color}
              color="#fff"
              disabled={disabledButtonNext}
              text={textButtonNext}
              width={152}
              type="submit"
            />
          }
        />
      </ButtonActionsWrapper>
      <MiniFooter refFooter={refFooter} />
    </Wrapper>
)};